export function confirm (vm, content, title = 'Attention !') {
  return vm.$confirm(
    {
      content: content,
      title: title,
      html: true,
      size: 'md',
      okText: 'Oui',
      okType: 'warning',
      cancelText: 'Non',
      cancelType: 'default'
    }
  )
}

export default {
  confirm
}
